// extracted by mini-css-extract-plugin
export default {"faqContainer":"index__faqContainer--kI-8s","title":"index__title--biDsD"};